import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { router } from "./routes";
import "./styles/globals.css";

console.log("[DEBUG] Iniciando aplicação");

const rootElement = document.getElementById("root");
console.log("[DEBUG] Elemento root:", rootElement);

if (!rootElement) {
  console.error("[ERROR] Elemento root não encontrado!");
  throw new Error("Elemento root não encontrado!");
}

const root = ReactDOM.createRoot(rootElement);
console.log("[DEBUG] Root criado");

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);

console.log("[DEBUG] Aplicação renderizada");
